import { EvIoGameSetupSettings, GameEntity } from '@okletsplay/core';
import { GameActivityType } from 'shared/enums';
import { GameSelectedSetting } from 'shared/interfaces';
import { prepareMatchSetupSettingsOptions } from 'shared/utils';

// Info: These code requires all properties defined in EvIoGameSetupSettings to be present in array of keys.
const GAME_MATCH_SETUP_SETTINGS = Object.keys({
  damageMultiplier: '',
  gameDuration: '',
  gameMode: '',
  gravity: '',
  killsToWin: '',
  map: '',
  region: '',
  timeVelocity: '',
} as Omit<Record<keyof EvIoGameSetupSettings, string>, 'maxGameDuration'>);

export const getEvIoMatchSetupSettingsOptions = (
  settings: EvIoGameSetupSettings | undefined,
  game: GameEntity | undefined,
  gameActivity: GameActivityType
): GameSelectedSetting[] => {
  if (!game || !settings) return [];

  const meta =
    gameActivity === GameActivityType.Match
      ? game.matchesConfiguration?.matchSetupSettings?.properties
      : game.tournamentsConfiguration?.matchSetupSettings?.properties;

  const filteredSettings = Object.fromEntries(
    Object.entries(settings).filter(([key]) => GAME_MATCH_SETUP_SETTINGS.includes(key))
  );

  const result = prepareMatchSetupSettingsOptions({
    settings: filteredSettings as unknown as Record<string, string | number>,
    meta,
  });

  if (gameActivity === GameActivityType.Match) {
    result.unshift({ label: 'Players', value: '1v1' });
  }

  return result;
};
